import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigation } from '../../hooks/useNavigation';
import { clearErrorMessage } from '../../store/errorSlice';
import { ModalOverlay, ModalWrapper, Title, Content, ErrorMessage } from './Modal.styled';

interface ModalProps {
  title: string;
  time: number;
  content?: string;
  errorMessage?: string;
  onMount?: () => void | Promise<void>;
  customNavigationText?: string;
  onTimeEnd?: () => void;
}

/**
 * @param {string} title 모달 타이틀
 * @param {number} time 시작화면으로 돌아갈 때까지의 시간(초)
 * @param {string} content 'n초 후 시작화면으로 돌아가요' 이외에 필요한 추가적인 메시지
 * @param {string} errorMessage 빨간 텍스트로 표시할 에러 메시지
 * @param {(() => void | Promise<void>) | null} onMount 로깅 등 모달 렌더링 시 실행할 함수
 * @param {string} customNavigationText 타이머 종료 후 이동 메시지 (기본값: "시작화면으로 돌아가요")
 * @param {() => void} onTimeEnd 타이머 종료 시 실행할 콜백 함수. 설정하지 않으면 시작화면으로 이동
 * @todo 모달의 기본 타이머 동작, 텍스트 등을 제거하고 모든 동작을 커스터마이즈 가능하도록 개선 필요 (현재는 customNavigationText와 onTimeEnd로 커스터마이즈 가능)
 */
export function Modal({
  title,
  time,
  content,
  errorMessage,
  onMount,
  customNavigationText = '시작화면으로 돌아가요. 결제가 되었다면 채널로 문의해주세요.',
  onTimeEnd,
}: ModalProps) {
  const [restTime, setRestTime] = useState<number>(time);
  const { navigateToStart } = useNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setInterval(() => {
      setRestTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          dispatch(clearErrorMessage());

          if (onTimeEnd) {
            onTimeEnd();
          } else {
            navigateToStart();
          }

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigateToStart, dispatch, onTimeEnd]);

  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, []);

  return (
    <ModalOverlay>
      <ModalWrapper>
        <Title>{title}</Title>
        <Content>
          {restTime}초 후 {customNavigationText}
          {content && <>&nbsp;{content}</>}
        </Content>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </ModalWrapper>
    </ModalOverlay>
  );
}
